/**
 * Top strip HUD: a small raised chip at the top-left showing the live
 * population count next to a creature glyph. Read-only — no pointer events.
 */
import { injectBaseStyles } from './win94';

export class Hud {
  private readonly el: HTMLDivElement;
  private readonly countEl: HTMLSpanElement;
  private population = 0;

  constructor(parent: HTMLElement) {
    injectBaseStyles();
    this.el = document.createElement('div');
    this.el.className = 'w94-raised w94-font';
    this.el.style.cssText = [
      'position:fixed',
      'top:calc(6px + env(safe-area-inset-top))',
      'left:6px',
      'display:flex',
      'align-items:center',
      'gap:6px',
      'padding:4px 8px',
      'pointer-events:none',
      'user-select:none',
      '-webkit-user-select:none',
      'z-index:20',
    ].join(';');

    // egg/creature glyph spot — placeholder until real sprites land
    const glyph = document.createElement('canvas');
    glyph.width = 12;
    glyph.height = 12;
    glyph.style.cssText = 'width:12px;height:12px;image-rendering:pixelated';
    const ctx = glyph.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#B8960C';
      ctx.fillRect(0, 0, 12, 12);
    }

    this.countEl = document.createElement('span');
    this.countEl.style.cssText = [
      "font:bold 16px Consolas,'Courier New',monospace",
      'color:var(--w94-text)',
      'font-variant-numeric:tabular-nums',
    ].join(';');
    this.countEl.textContent = '0';

    this.el.append(glyph, this.countEl);
    parent.appendChild(this.el);
  }

  setPopulation(n: number): void {
    if (n === this.population) return;
    this.population = n;
    this.countEl.textContent = String(n);
  }
}
